import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import RiskAssessmentDashboard from "./LeakDectionDashBoard";
import {
  convertDateToEpochUTC,
  convertEpochtoDate,
} from "../../../../helper/DateConverters";
import { Calendar } from "primereact/calendar";
import VehicleAssessmentDashboard from "./VehicleAssessmentDashBoard";
import { Button } from "primereact/button";
import { ROLES } from "../../../../util/roleNameConstants";

const HsDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [date, setDate] = useState<any>(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return convertDateToEpochUTC(today);
  });

  const getOriginalDate = (date: string | null): Date | null => {
    if (!date) return null;
    const formattedDate = convertEpochtoDate(date, "getDateValue");
    const dateObject = new Date(formattedDate + "T00:00:00");
    return dateObject;
  };

  const InvoiceDateConst = (date: any, type: string): void | null => {
    if (!date) return null;
    const offsetSeconds = new Date().getTimezoneOffset() * 60;
    const formattedDate = Math.floor(date.getTime() / 1000.0) - offsetSeconds;
    setDate(formattedDate);
  };

  return (
    <div className="tw-mt-[-10px] tw-w-full">
      <Card className="tw-shadow-sm tw-rounded-lg tw-border tw-border-gray-200 tw-w-full">
        <h1 className="tw-text-xl tw-font-bold tw-text-gray-800">
          Health and Safety Dashboard
        </h1>
        <div className="tw-flex tw-justify-end tw-items-center tw-gap-4">
          <label className="tw-font-bold">Date:</label>
          <Calendar
            value={getOriginalDate(date) as any}
            className="tw-px-[7px] tw-py-[2px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-[38px] placeholder:tw-font-normal tw-w-full md:tw-w-auto tw-cursor-pointer"
            dateFormat="dd-mm-yy"
            placeholder="Select date"
            onChange={(e) => {
              e.stopPropagation();
              InvoiceDateConst(e.value, "update");
            }}
            showIcon
            readOnlyInput
            hideOnRangeSelection
          />
        </div>
        {localStorage.roleName.includes(ROLES.HANDS_ADMIN) && (
          <>
            <div className="tw-flex tw-flex-wrap tw-justify-start tw-items-center tw-gap-2 sm:tw-gap-4">
              <Button
                type="button"
                onClick={() => setActiveIndex(0)}
                className={`tw-bg-transparent ${
                  activeIndex === 0
                    ? "tw-border-0 tw-border-b-2 tw-rounded-lg tw-bg-[#E8F9FF] tw-border-b-solid tw-border-b-[#00AFEE] tw-rounde tw-text-gray-900"
                    : "tw-text-gray-500"
                } focus:tw-shadow-none tw-px-4 tw-py-1 tw-text-base sm:tw-text-xl tw-font-semibold`}
              >
                Risk Assessment
              </Button>
              <Button
                type="button"
                onClick={() => setActiveIndex(1)}
                className={`tw-bg-transparent ${
                  activeIndex === 1
                    ? "tw-border-0 tw-border-b-2 tw-rounded-lg tw-bg-[#E8F9FF] tw-border-b-solid tw-border-b-[#00AFEE] tw-one tw-text-gray-900"
                    : "tw-text-gray-500"
                } focus:tw-shadow-none tw-px-4 tw-py-1 tw-text-base sm:tw-text-xl tw-font-semibold`}
              >
                Daily Vehicle Check Sheet
              </Button>
            </div>
          </>
        )}
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="[&_.p-tabview-nav]:tw-bg-transparent time-log-tab"
        >
          <TabPanel header="Risk Assessment">
            <RiskAssessmentDashboard date={date} setDate={setDate} />
          </TabPanel>
          <TabPanel header="Daily Vehicle Check Sheet">
            <VehicleAssessmentDashboard date={date} setDate={setDate} />
          </TabPanel>
        </TabView>
      </Card>
    </div>
  );
};

export default HsDashBoard;
